import { useAuth } from '../contexts/AuthContext';
import { UserCog } from 'lucide-react';

export default function SupportModeBar() {
  const { isInSupportMode, originalUser, currentUser, endSupportLogin } = useAuth();

  if (!isInSupportMode) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-primary text-gray-900 px-4 py-2 flex items-center justify-between shadow-md">
      <div className="flex items-center gap-2">
        <UserCog size={20} />
        <span className="font-medium">
          Modo Suporte: Visualizando como {currentUser?.displayName || currentUser?.email}
        </span>
      </div>
      <button
        onClick={endSupportLogin}
        className="bg-white text-gray-900 px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
      >
        Voltar para {originalUser?.displayName || originalUser?.email}
      </button>
    </div>
  );
}
